const btnProps = {
  variant: {
    type: String,
    default: 'primary',
  },
  tag: {
    type: String,
    default: 'button',
    validator(value) {
      return ['button', 'a', 'span'].indexOf(value) !== -1;
    },
  },
};

export default {
  name: 'MButton',
  props: {
    ...btnProps,
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
  render(createElement) {
    const variantKey = `btn-${this.variant}`;

    return createElement(this.tag, {
      class: {
        btn: true,
        [variantKey]: true,
      },
      on: {
        click: this.handleClick,
      },
    }, this.$slots.default);
  },
};
